import React from 'react';
import { Button, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setportfolioMasterTabValue } from '../../redux/PortfolioMaster/portfolioMasterSlice';

const CustomTabs = ({ tabs, selectedTab, onTabChange, disabled, disabledTabs = [] }) => {
  const dispatch = useDispatch();
  const handleTabChange = (tabId) => {
    if (!disabledTabs.includes(tabId)) {
      // Check if tab is not in the disabledTabs array
      dispatch(setportfolioMasterTabValue(tabId)); // Dispatch Redux action
      onTabChange(tabId); // Trigger the tab change callback
    }
  };

  return (
    <Stack direction="row" gap="10px" role="tablist" flexWrap={'wrap'}>
      {tabs.map(({ id: tabId, name: tabName }) => {
        const isSelected = selectedTab === tabId;
        const isDisabled = disabledTabs.length ? disabledTabs.includes(tabId) : false;

        return (
          <Button
            key={tabId}
            sx={{
              border: isSelected ? '1px solid #005CBC' : 'none',
              borderRadius: '8px',
              fontWeight: isSelected ? '700' : '400',
              backgroundColor: isSelected ? '#FBFCFE' : 'transparent',
              height: '32px',
              textTransform: 'none',
              color: isDisabled ? '#A0A0A0' : '#3A3A3A'
            }}
            onClick={() => handleTabChange(tabId)}
            aria-selected={isSelected}
            aria-controls={`tabpanel-${tabId}`}
            role="tab"
            disabled={isDisabled} // Disable button click if the tab is in the disabledTabs list
          >
            {tabName}
          </Button>
        );
      })}
    </Stack>
  );
};

export default CustomTabs;
